import {
    ORDER_BALANCE_STOCK_REPORT_REQUEST,
    ORDER_BALANCE_STOCK_REPORT_SUCCESS,
    ORDER_BALANCE_STOCK_REPORT_FAILURE,
    ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST,
    ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS,
    ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE,
    ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS,
    SET_OUTSTANDING_BY_ACCOUNTS
  } from "../types/order-balance-stock-report-types";
  
  const initialState = {
    orderBalanceBillBaseStockReport: {},
    orderBalanceBillBaseStockFilterOptions: {},
    orderBalanceChallanBaseStockReport: {},
    outstandingByAccounts: {},
    loading: false,
    error: null,
  };
  
  const orderBalanceStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case ORDER_BALANCE_STOCK_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null,
          orderBalanceBillBaseStockReport: {}
        };
      }
      case ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case ORDER_BALANCE_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          orderBalanceBillBaseStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          orderBalanceBillBaseStockFilterOptions: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          orderBalanceChallanBaseStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SET_OUTSTANDING_BY_ACCOUNTS: {
        return {
          ...state,
          outstandingByAccounts: {...(action.payload || {})},
          loading: false,
          error: null
        }
      }
      case ORDER_BALANCE_STOCK_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default orderBalanceStockReportReducer;
  